import React, { useEffect, useState, useMemo } from "react";
import CustomButton from "../../AppComponent/CustomButton/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import {
  settheQueryQuestionActions,
  setTheSubQueryIDs,
  setTheQueryQuestionsDeleteActions, ///delete
} from "../../../Redux/Slice";
import { NavLink, useNavigate } from "react-router-dom";
import ReactTable from "../../AppComponent/Table";
import Select from "react-select";
import Delete from "../../AppComponent/Popup/Delete";
import Search from "@mui/icons-material/Search";
import QueryActions from "./QueryActions";
import _ from "lodash";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import ViewSymblos from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-23.svg";

const Query = () => {
  const dispatch = useDispatch();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );

  const state = useSelector((state) => state);
  const [RoleCreatePopup, setRoleCreatePopup] = useState(false);
  const [newpages, setNewpage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [search, setsearch] = useState("");
  const [pageSize, setPageSize] = useState(20);
  const [DeletePOPUP, setDeletePOPUP] = useState(false);
  const [DeleteID, setDeleteID] = useState("");
  const [EditId, setEditID] = useState();

  const navigator = useNavigate();
  useEffect(() => {
    const payload = {
      search: search,
      page_size: dtpagesize,
      page: dtpageindex,
    };
    dispatch(settheQueryQuestionActions(payload));
  }, [dtpageindex, dtpagesize,search]);

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
  setsearch(e)
      }, 500),
    []
  );

  function tochange(e) {
    debouncedSearch(e); 
  }

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);
  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    setdtPageindex(arg);
  };



  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);

}
};
  const columns = [
    {
      Header: "Ticket",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.name ? (
              <span>{row.row.original.name}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Description",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.description ? (
              <span>{row.row.original.description}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Created date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <span>
              {`${
                row.row.original.created_at.slice(0, 10) + "  " + formattedTime
              }`}
            </span>
          </>
        );
      },
    },

    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "5px",
              }}
            >
              <button
                className=" btn Status"
                onClick={(e) => {
                  e.stopPropagation();

                  setEditID(row.row.original.id);
                  setRoleCreatePopup(true);
                }}
                component="span"
              >
                <span className="OuterActionSpan">
                <span  className="EditImages">
                    <img src={EditImages}/>
                  </span>
                  <span className="ActionsList"> Edit </span>
                </span>
              </button>

              <button
                type="button"
                class="btn Status"
                onClick={(e) => {
                  e.stopPropagation();
                  setDeleteID(row.row.original.id);
                  setDeletePOPUP(true);
                }}
              >
                <span className="OuterActionSpan">
                <span  className="EditImages">
                    <img src={DeleteImages}/>
                  </span>

                  <span className="ActionsList"> Delete </span>
                </span>{" "}
              </button>

              <button
                type="button"
                class="btn Status"
                onClick={(e) => {
                  e.stopPropagation();

                  dispatch(setTheSubQueryIDs(row.row.original.id));
                  if (
                    row.row.original.id == state.NeededdatasListed.SubQueryIDs
                  ) {
                    navigator("/ticketsubcategory");
                  }
                }}
              >
<span className="OuterActionSpan">
<span  className="EditImages">
                    <img src={ViewSymblos}/>
                  </span>

                  <span className="ActionsList"> View </span>
                </span>
              </button>
            </div>
          </>
        );
      },
    },
  ];

  const ViewFunctions = (e) => {
    dispatch(setTheSubQueryIDs(e.id));
    if (e.id == state.NeededdatasListed.SubQueryIDs) {
      navigator("/ticketsubcategory");
    }
  };
  const HandleDeletes = () => {
    if (DeleteID != undefined) {
      console.log(currentPage, "sdsd");
      const payload = {
        DeleteId: DeleteID,
        currentPage: dtpageindex,
      };
      dispatch(
        setTheQueryQuestionsDeleteActions(payload, setDeletePOPUP(false))
      );
    }
  };

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Ticket Category</h3>
          </div>
          <div className="Add-User col-sm-5">
            <button
              onClick={(e) => {
                setRoleCreatePopup(true);
                setEditID("");
              }}
              className="ButtonCSS"
            >

              Create 
            </button>
          </div>
        </div>
<br/>
        <div style={{ padding: " 0px 40px", marginTop: "-13px" }}>
          <ReactTable
            data={state.QueryQuetionsDatas.QueryQuestionsDatas}
            columns={columns}
            totalItems={state.QueryQuetionsDatas.Total_Count}
            currentPage={currentPage}
            onChange={tochange}
            setCurrentPage={setCurrentPage}
            pagesize={pagesize}
            dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}
            pageindex={pageindex}
            datacount={state.QueryQuetionsDatas.Total_Count}
            // onPageChange={handlePageChange}
            // onFirstPage={handleFirstPage}
            // OnhandleLastpgae={HandleLastPage}
            // value={state.NumberCounts.Options}
            // options={options}
            // Filter={false}
            // count={count}
            // ClearState={ClearState}
            // placeHold={place}

            MakeCreate={true}
            ViewParts={(e) => {
              ViewFunctions(e);
            }}
            Filter={true}
            NoFilter ={true}
            
          />
        </div>
      </div>

      {RoleCreatePopup ? (
        <QueryActions
          setShow={setRoleCreatePopup}
          show={RoleCreatePopup}
          currentPage={dtpageindex}
          EditID={EditId}
          search={search}
        />
      ) : null}

      {DeletePOPUP ? (
        <Delete
          show={DeletePOPUP}
          setShow={setDeletePOPUP}
          onSubmit={HandleDeletes}
          Content={"Do you want to delete the Ticket Category"}

        />
      ) : null}
    </>
  );
};

export default Query;
